import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translations } from '@/locales/index';

const languages = ['pt', 'en', 'es'];

// Exportamos apenas a instância. A inicialização será feita nos Apps.
export default i18n;

export const initI18n = (locale: string = 'pt') => {
  if (!i18n.isInitialized) {
    i18n
      .use(initReactI18next)
      .init({
        resources: {
          pt: { translation: translations.pt },
          en: { translation: translations.en },
          es: { translation: translations.es },
        },
        lng: locale,
        fallbackLng: 'pt',
        supportedLngs: languages,
        interpolation: {
          escapeValue: false,
        },
      }, (err) => {
        if (err) console.error('[i18n] Error during initialization:', err);
      });
  } else if (i18n.language !== locale) {
    i18n.changeLanguage(locale);
  }
};
